export const style = {
  header: {
    size: 'lg',
    textAlign: 'center',
    paddingY: 7,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 5,
    paddingX: 12,
    paddingY: 7,
  },
  button: {
    w: 'full',
    marginY: 2,
  },
  ul: {
    marginLeft: 6,
  },
};
